import { navigate } from "gatsby";
import React, { useContext } from "react";
import arrowDownIcon from "../../../assets/images/arrow-down.svg";
import { localLanguageNames } from "../../../context/LocalizationContext";
import { PageContext } from "../../../context/PageContext";
import useTranslations from "../../../hooks/useTranslations";
import { ToolNavigationItem } from "../../../models/navigation/ToolNavigationItem";

interface Props extends ToolNavigationItem {
  fontClass: string;
  optionClassName?: string;
}

export const LanguageToolLink = (props: Props) => {
  const { fontClass, optionClassName } = props;

  const translations = useTranslations();

  const { i18nLang: currentLanguage, languages } = useContext(PageContext);

  const languageOptions = languages ? [...languages] : [];

  languageOptions.unshift({
    languageId: currentLanguage ?? "",
    currentPageLanguageUrl: null
  });

  // add some left padding to make the option visible in chrome with standard dropdown control
  const className =
    "text-inherit appearance-none rounded-none pl-1 -ml-1 pr-4 cursor-pointer font-bold no-underline focus:shadow-outline focus:outline-none bg-transparent focus:bg-neutral-100";

  const onChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;

    if (!url) {
      return;
    }

    navigate(url);
  };

  return (
    <div className={`${fontClass} inline-flex items-center relative`}>
      <select
        aria-label={translations.currentLanguageSelectLabel ?? undefined}
        className={className}
        onChange={onChange}
        defaultValue={currentLanguage}
      >
        {languageOptions?.map((lang, index) => (
          <option
            className={optionClassName}
            key={index}
            value={lang.currentPageLanguageUrl || undefined}
          >
            {localLanguageNames[lang.languageId]}
          </option>
        ))}
      </select>

      <svg
        width={11}
        height={11}
        className="stroke-current absolute right-0 pointer-events-none !text-inherit"
      >
        <use xlinkHref={arrowDownIcon.url} />
      </svg>
    </div>
  );
};

